export default __webpack_public_path__ + "static/artifakt-element-bold-60197c4b468b0243ef1253da10f10b1d.woff";